import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";

interface IServerResponse {
  status: any;
  message: string;
  result: any;
  count?: number;
  page?: number;
  totalPages?: number;
}

const API_URL = environment.API_URL + "/admin";

@Injectable()
export class GeventService {
  admin_data: any = JSON.parse(localStorage.getItem("user"));

  constructor(private https: Http) { }

  getTicketTypes(page: number = 1, limit: number = 15, search: string = ""): Observable<IServerResponse> {
    let query = `?page=${page}&limit=${limit}`;
    if (search && search.trim() !== "") {
      query += `&search=${encodeURIComponent(search.trim())}`;
    }
    return this.https.get(API_URL + "/gevent/ticket-types" + query).pipe(map((res) => res.json()));
  }

  getTicketTypeById(id: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/gevent/ticket-type/get-by-id?id=" + id)
      .pipe(map((res) => res.json()));
  }

  createTicketType(payload: any): Observable<IServerResponse> {
    payload.admin_id = this.admin_data && this.admin_data._id ? this.admin_data._id : "";
    return this.https
      .post(API_URL + "/gevent/ticket-type/create", payload)
      .pipe(map((res) => res.json()));
  }

  updateTicketType(payload: any): Observable<IServerResponse> {
    payload.admin_id = this.admin_data && this.admin_data._id ? this.admin_data._id : "";
    return this.https
      .post(API_URL + "/gevent/ticket-type/update", payload)
      .pipe(map((res) => res.json()));
  }

  deleteTicketType(id: string): Observable<IServerResponse> {
    const payload = {
      id: id,
      admin_id: this.admin_data && this.admin_data._id ? this.admin_data._id : "",
    };
    return this.https
      .post(API_URL + "/gevent/ticket-type/delete", payload)
      .pipe(map((res) => res.json()));
  }

  updateTicketTypeOrder(ticketTypes: string[]): Observable<IServerResponse> {
    const payload = {
      admin_id: this.admin_data && this.admin_data._id ? this.admin_data._id : "",
      ticket_types: ticketTypes,
    };
    return this.https
      .post(API_URL + "/gevent/ticket-type/update-order", payload)
      .pipe(map((res) => res.json()));
  }

  getAllEvents(page: number = 1, limit: number = 15, search: string = "", status: string = ""): Observable<IServerResponse> {
    let query = `?page=${page}&limit=${limit}`;
    if (search && search.trim() !== "") {
      query += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (status && status.trim() !== "") {
      query += `&status=${encodeURIComponent(status.trim())}`;
    }
    return this.https.get(API_URL + "/gevent/events" + query).pipe(map((res) => res.json()));
  }

  getEventDetails(id: string): Observable<IServerResponse> {
    const adminId = this.admin_data && this.admin_data._id ? this.admin_data._id : "";
    return this.https
      .get(API_URL + "/gevent/event/" + id + "?admin_id=" + adminId)
      .pipe(map((res) => res.json()));
  }

  approveOrRejectEvent(
    event_id: string,
    action: "approved" | "declined" | "cancelled" | "settlement_approved",
    declined_reason?: string
  ): Observable<IServerResponse> {
    const payload: any = {
      admin_id: this.admin_data && this.admin_data._id ? this.admin_data._id : "",
      event_id,
      action,
    };
    if (declined_reason) {
      payload.declined_reason = declined_reason;
    }
    return this.https
      .post(API_URL + "/gevent/event/approve-reject", payload)
      .pipe(map((res) => res.json()));
  }

  getPurchasesByEvent(
    event_id: string,
    page: number = 1,
    limit: number = 15,
    search: string = "",
    status: string = "",
    ticket_inventory_id: string = ""
  ): Observable<IServerResponse> {
    let query = `?event_id=${encodeURIComponent(event_id)}&page=${page}&limit=${limit}`;
    if (search && search.trim() !== "") {
      query += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (status && status.trim() !== "") {
      query += `&status=${encodeURIComponent(status.trim())}`;
    }
    if (ticket_inventory_id && ticket_inventory_id.trim() !== "") {
      query += `&ticket_inventory_id=${encodeURIComponent(ticket_inventory_id.trim())}`;
    }
    return this.https
      .get(API_URL + "/gevent/purchases" + query)
      .pipe(map((res) => res.json()));
  }

  getTicketInventories(event_id: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/gevent/ticket-inventories?event_id=" + encodeURIComponent(event_id))
      .pipe(map((res) => res.json()));
  }

  getReminderSettings(): Observable<IServerResponse> {
    return this.https.get(API_URL + "/gevent/reminder-settings").pipe(map((res) => res.json()));
  }

  saveReminderSettings(payload: any): Observable<IServerResponse> {
    return this.https
      .post(API_URL + "/gevent/reminder-settings", payload)
      .pipe(map((res) => res.json()));
  }
}
